// {first_name} as the person will see it; with no name, the placeholder and
// its leading comma drop out ("Thanks, {first_name}!" -> "Thanks!").
export function fillName(text, name) {
  if (name) return (text || "").replaceAll("{first_name}", name);
  return (text || "").replace(/,?\s*\{first_name\}/g, "");
}
